
// ProducaoPage.js

import React from 'react';
import Header from '../../components/Header.js';
import { useTheme } from '../../contexts/ThemeContext.js'; // Importe o contexto de tema

function ProducaoPage() {

  const { theme } = useTheme(); // Use o contexto de tema para acessar o tema selecionado

  return (

    <div style={{ 
      backgroundColor: theme.background, 
      color: theme.color,
      minHeight: 'calc(100vh - 20px)', // Altura mínima da página é 100% da viewport height menos 20px
      width: '100%', // Largura da página é 100%
      paddingTop: '10px' // Espaçamento de 10px do topo
    }}>


    <Header selectedCompany={localStorage.getItem('selectedCompany')} /> {/* Passe a propriedade selectedCompany */}
      <h3 style={{ textAlign: 'center' }}>Controle de Produção</h3> {/* Alinhe o título ao centro */}
    {/* Conteúdo da página Administrativo */}


    </div>
  );
}

export default ProducaoPage;